<div class="customizer border-left-blue-grey border-left-lighten-4 d-none d-xl-block hc-customizer" id="customizer">
  <a [routerLink]="" class="customizer-close" (click)="toggleCustomizer($event)"><i class="feather ft-x font-medium-3"></i></a>
  <a [routerLink]="" class="customizer-toggle bg-danger box-shadow-3" (click)="toggleCustomizer($event)"><i
      class="feather ft-activity font-medium-3 white"></i></a>
  <div class="customizer-content p-2 hc-customizer-content" fxFlex="auto" [perfectScrollbar]="config">

    <div class="hc-tabs" role="tablist" aria-label="Schnellzugriff">
      <button type="button" class="hc-tab" role="tab" [attr.aria-selected]="activePanel === 'ki'"
        [class.active]="activePanel === 'ki'" (click)="selectPanel('ki')" title="KI-Bot">
        <i class="feather ft-message-square" aria-hidden="true"></i>
        <span class="sr-only">KI-Bot</span>
      </button>
      <button type="button" class="hc-tab" role="tab" [attr.aria-selected]="activePanel === 'phone'"
        [class.active]="activePanel === 'phone'" (click)="selectPanel('phone')" title="Telefonliste">
        <i class="feather ft-phone" aria-hidden="true"></i>
        <span class="sr-only">Telefonliste</span>
      </button>
      <button type="button" class="hc-tab" role="tab" [attr.aria-selected]="activePanel === 'appointment'"
        [class.active]="activePanel === 'appointment'" (click)="selectPanel('appointment')" title="Terminmanager">
        <i class="feather ft-calendar" aria-hidden="true"></i>
        <span class="sr-only">Terminmanager</span>
      </button>
      <button type="button" class="hc-tab" role="tab" [attr.aria-selected]="activePanel === 'email'"
        [class.active]="activePanel === 'email'" (click)="selectPanel('email')" title="E-Mail">
        <i class="feather ft-mail" aria-hidden="true"></i>
        <span class="sr-only">E-Mail</span>
      </button>
      <button type="button" class="hc-tab" role="tab" [attr.aria-selected]="activePanel === 'orders'"
        [class.active]="activePanel === 'orders'" (click)="selectPanel('orders')" title="Letzte Aufträge">
        <i class="feather ft-layers" aria-hidden="true"></i>
        <span class="sr-only">Letzte Aufträge</span>
      </button>
    </div>

    <div class="hc-body-wrap">
    <!-- KI-Bot -->
    <div *ngIf="activePanel === 'ki'" class="hc-panel hc-panel-fill" role="tabpanel">
      <div class="hc-n8n-chat-wrap">
        <app-n8n-chat></app-n8n-chat>
      </div>
    </div>

    <!-- Telefonliste (Sipgate-Historie wie Dashboard) -->
    <div *ngIf="activePanel === 'phone'" class="hc-panel hc-phone-panel hc-panel-fill" role="tabpanel">
      <div class="hc-phone-toolbar small text-muted mb-2" *ngIf="!loadingSipgateCalls && !sipgateError">
        Sipgate · {{ sipgateCalls.length }} von {{ sipgateHistoryTotal }} Einträgen
      </div>
      <div *ngIf="loadingSipgateCalls" class="hc-phone-loading">
        <div class="hc-phone-loading-inner">
          <div class="spinner-border text-primary hc-phone-spinner" role="status" aria-hidden="true"></div>
          <span class="sr-only">Lädt</span>
          <p class="text-muted small mt-3 mb-0">Telefonliste wird geladen…</p>
        </div>
      </div>
      <div *ngIf="sipgateError" class="alert alert-warning small mb-2 py-2 flex-shrink-0">{{ sipgateError }}</div>
      <div class="hc-call-list table-responsive" *ngIf="!loadingSipgateCalls && !sipgateError">
        <table class="table table-sm table-striped table-hover mb-0 hc-call-table" *ngIf="sipgateCalls.length > 0">
          <thead>
            <tr>
              <th>I/O</th>
              <th>vor</th>
              <th>Datum / Zeit</th>
              <th>Name</th>
              <th>Auftr.</th>
            </tr>
          </thead>
          <tbody>
            <tr
              *ngFor="let call of sipgateCalls"
              [class.hc-tr-order]="call.order_id"
              [class.hc-tr-clickable]="call.order_id"
              (click)="navigateToOrder(call)"
            >
              <td class="hc-td-io text-nowrap">
                <span class="hc-io" title="Richtung">
                  <i *ngIf="call.direction === 'INCOMING'" class="fa fa-arrow-down text-success"></i>
                  <i *ngIf="call.direction === 'OUTGOING'" class="fa fa-arrow-up text-danger"></i>
                  <i *ngIf="call.direction === 'MISSED_INCOMING'" class="fa fa-arrow-down text-warning"><span class="badge badge-warning hc-m-badge">M</span></i>
                  <i *ngIf="call.direction === 'MISSED_OUTGOING'" class="fa fa-arrow-up text-danger"></i>
                </span>
                <span class="hc-type ml-1" title="Typ">
                  <i *ngIf="call.type === 'CALL' && call.direction !== 'MISSED_INCOMING' && call.direction !== 'MISSED_OUTGOING'" class="fa fa-phone"></i>
                  <i *ngIf="call.type === 'CALL' && (call.direction === 'MISSED_INCOMING' || call.direction === 'MISSED_OUTGOING')" class="fa fa-phone" style="text-decoration: line-through;"></i>
                  <i *ngIf="call.type === 'SMS'" class="fa fa-comment"></i>
                  <i *ngIf="call.type === 'FAX'" class="fa fa-fax"></i>
                </span>
              </td>
              <td class="hc-td-vor small text-muted text-nowrap">vor {{ getTimeDifference(call.created) }}</td>
              <td class="hc-td-datetime">
                <div class="hc-datetime-date">{{ call.created | date:'dd.MM.yyyy' }}</div>
                <div class="hc-datetime-time text-muted">{{ call.created | date:'HH:mm' }} Uhr</div>
              </td>
              <td class="hc-td-name">
                <div class="hc-name-line">{{ getNameFirstLine(call) }}</div>
                <div class="hc-name-line hc-name-line--last" *ngIf="hasStructuredName(call)">{{ getNameSecondLine(call) }}</div>
              </td>
              <td class="hc-td-order small text-nowrap">{{ call.order_number != null && call.order_number !== '' ? call.order_number : '–' }}</td>
            </tr>
          </tbody>
        </table>
        <p *ngIf="sipgateCalls.length === 0" class="text-muted small mb-0">Keine Einträge in der Historie.</p>
      </div>
      <a *ngIf="!loadingSipgateCalls" [routerLink]="['/contacts']" class="btn btn-sm btn-link p-0 mt-2 d-block hc-phone-footer">Kontakte öffnen</a>
    </div>

    <!-- Terminmanager (Daten wie appointment-requests-manager, Listenstil wie Telefonliste) -->
    <div *ngIf="activePanel === 'appointment'" class="hc-panel hc-appointment-panel hc-panel-fill" role="tabpanel">
      <div class="hc-appointment-toolbar" *ngIf="!loadingAppointmentRequests && !appointmentError">
        <input type="search" class="form-control form-control-sm hc-appointment-search"
          placeholder="Suche: Auftragsnr., Name, E-Mail …"
          [(ngModel)]="appointmentSearch" (ngModelChange)="applyAppointmentFilter()">
        <div class="small text-muted" *ngIf="appointmentRequestsList.length">
          {{ appointmentRequestsFiltered.length }} von {{ appointmentRequestsList.length }} Einträgen
        </div>
      </div>
      <div *ngIf="loadingAppointmentRequests" class="hc-phone-loading">
        <div class="hc-phone-loading-inner">
          <div class="spinner-border text-primary hc-phone-spinner" role="status" aria-hidden="true"></div>
          <span class="sr-only">Lädt</span>
          <p class="text-muted small mt-3 mb-0">Terminanfragen werden geladen…</p>
        </div>
      </div>
      <div *ngIf="appointmentError" class="alert alert-warning small mb-2 py-2 flex-shrink-0">{{ appointmentError }}</div>
      <div class="hc-call-list table-responsive" *ngIf="!loadingAppointmentRequests && !appointmentError">
        <table class="table table-sm table-striped table-hover mb-0 hc-call-table" *ngIf="appointmentRequestsFiltered.length > 0">
          <thead>
            <tr>
              <th>Auftragsnr.</th>
              <th>Name</th>
              <th>E-Mail</th>
              <th>Status</th>
            </tr>
          </thead>
          <tbody>
            <tr
              *ngFor="let item of appointmentRequestsFiltered"
              [class.hc-tr-order]="item.order_id"
              [class.hc-tr-clickable]="item.order_id"
              [attr.title]="getAppointmentRowTitle(item) || null"
              (click)="navigateToAppointmentOrder(item)"
            >
              <td class="text-nowrap">{{ item.order_number != null && item.order_number !== '' ? item.order_number : '–' }}</td>
              <td>{{ item.name }}</td>
              <td class="small">{{ item.email != null && item.email !== '' ? item.email : '–' }}</td>
              <td class="text-nowrap">
                <span class="status-badge status-confirmed" *ngIf="getAppointmentStatus(item) === 'confirmed'">
                  <i class="fa fa-check-circle"></i> {{ getAppointmentStatusLabel(item) }}
                </span>
                <span class="status-badge status-declined" *ngIf="getAppointmentStatus(item) === 'declined'">
                  <i class="fa fa-times-circle"></i> {{ getAppointmentStatusLabel(item) }}
                </span>
                <span class="status-badge status-pending" *ngIf="getAppointmentStatus(item) === 'pending'">
                  <i class="fa fa-clock-o"></i> {{ getAppointmentStatusLabel(item) }}
                </span>
              </td>
            </tr>
          </tbody>
        </table>
        <p *ngIf="appointmentRequestsFiltered.length === 0 && appointmentRequestsList.length === 0" class="text-muted small mb-0">Keine Terminanfragen.</p>
        <p *ngIf="appointmentRequestsFiltered.length === 0 && appointmentRequestsList.length > 0" class="text-muted small mb-0">Keine Treffer für die Suche.</p>
      </div>

      <div class="hc-appointment-auto mt-3" *ngIf="!loadingAppointmentRequests && !appointmentError">
        <div class="small font-weight-bold mb-1">Automatisch übertragen (setTouren)</div>
        <div class="small text-muted mb-2" *ngIf="appointmentAutoTransferred.length">
          {{ appointmentAutoTransferred.length }} zuletzt erfolgreich
        </div>
        <div class="hc-call-list table-responsive" *ngIf="appointmentAutoTransferred.length > 0">
          <table class="table table-sm table-striped table-hover mb-0 hc-call-table">
            <thead>
              <tr>
                <th>Auftragsnr.</th>
                <th>Name</th>
                <th>Team</th>
                <th>Übertragen</th>
              </tr>
            </thead>
            <tbody>
              <tr
                *ngFor="let item of appointmentAutoTransferred"
                [class.hc-tr-order]="item.order_id"
                [class.hc-tr-clickable]="item.order_id"
                (click)="navigateToAppointmentOrder(item)"
              >
                <td class="text-nowrap">{{ item.order_number != null && item.order_number !== '' ? item.order_number : '–' }}</td>
                <td>{{ item.name }}</td>
                <td class="small">{{ item.team_base?.label || '–' }}</td>
                <td class="text-nowrap small">{{ formatAppointmentDate(item.set_touren_at) }}</td>
              </tr>
            </tbody>
          </table>
        </div>
        <p *ngIf="appointmentAutoTransferred.length === 0" class="text-muted small mb-0">Noch keine automatischen setTouren-Übertragungen.</p>
      </div>

      <a *ngIf="!loadingAppointmentRequests" [routerLink]="['/appointment-requests-manager']" class="btn btn-sm btn-link p-0 mt-2 d-block hc-phone-footer">Volle Ansicht Terminwünsche</a>
    </div>

    <!-- E-Mails (Daten wie Kommunikationsmanager, Listenstil wie Telefonliste) -->
    <div *ngIf="activePanel === 'email'" class="hc-panel hc-email-panel hc-panel-fill" role="tabpanel">
      <div class="hc-appointment-toolbar" *ngIf="!loadingMails && !mailError">
        <input type="search" class="form-control form-control-sm hc-appointment-search"
          placeholder="Suche: Auftragsnr., Name, E-Mail …"
          [(ngModel)]="mailSearch" (ngModelChange)="applyMailFilter()">
        <div class="small text-muted" *ngIf="mailsList.length">
          {{ mailsFiltered.length }} von {{ mailsList.length }} Einträgen
        </div>
      </div>
      <div *ngIf="loadingMails" class="hc-phone-loading">
        <div class="hc-phone-loading-inner">
          <div class="spinner-border text-primary hc-phone-spinner" role="status" aria-hidden="true"></div>
          <span class="sr-only">Lädt</span>
          <p class="text-muted small mt-3 mb-0">E-Mails werden geladen…</p>
        </div>
      </div>
      <div *ngIf="mailError" class="alert alert-warning small mb-2 py-2 flex-shrink-0">{{ mailError }}</div>
      <div class="hc-call-list table-responsive" *ngIf="!loadingMails && !mailError">
        <table class="table table-sm table-striped table-hover mb-0 hc-call-table" *ngIf="mailsFiltered.length > 0">
          <thead>
            <tr>
              <th>Auftragsnr.</th>
              <th>Name</th>
              <th>E-Mail</th>
              <th>Status</th>
            </tr>
          </thead>
          <tbody>
            <tr
              *ngFor="let mail of mailsFiltered"
              [class.hc-tr-order]="mail.order_id"
              [class.hc-tr-clickable]="mail.order_id"
              (click)="navigateToMailOrder(mail)"
            >
              <td class="text-nowrap">{{ mail.order_number != null && mail.order_number !== '' ? mail.order_number : '–' }}</td>
              <td>{{ getMailNameCell(mail) }}</td>
              <td class="small">{{ getMailEmailCell(mail) }}</td>
              <td class="text-nowrap">
                <span class="badge badge-primary" *ngIf="isMailIncoming(mail)">Eingang</span>
                <span class="badge badge-secondary" *ngIf="!isMailIncoming(mail)">Ausgang</span>
              </td>
            </tr>
          </tbody>
        </table>
        <p *ngIf="mailsFiltered.length === 0 && mailsList.length === 0" class="text-muted small mb-0">Keine E-Mails in der Datenbank.</p>
        <p *ngIf="mailsFiltered.length === 0 && mailsList.length > 0" class="text-muted small mb-0">Keine Treffer für die Suche.</p>
      </div>
      <a *ngIf="!loadingMails" [routerLink]="['/email']" class="btn btn-sm btn-link p-0 mt-2 d-block hc-phone-footer">Volle Ansicht Kommunikation</a>
    </div>

    <!-- Letzte Aufträge -->
    <div *ngIf="activePanel === 'orders'" class="hc-panel hc-panel-placeholder hc-panel-fill" role="tabpanel">
      <p class="text-muted small mb-2">Aufträge durchsuchen und öffnen.</p>
      <a [routerLink]="['/order']" class="btn btn-sm btn-outline-secondary">Zu den Aufträgen</a>
    </div>

    </div>

  </div>
</div>
